import React, { useState } from 'react';
import WorkflowUtilityPanel from './WorkflowUtilityPanel';

const WorkflowCommentsPanel = ({ comments = [], onClose, onAddComment }) => {
  const [text, setText] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    const value = text.trim();
    if (!value) return;
    onAddComment?.(value);
    setText('');
  };

  return (
    <WorkflowUtilityPanel title="Comments" onClose={onClose} testId="workflow-comments-panel">
      <form onSubmit={handleSubmit} className="mb-4">
        <textarea
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="Add a comment..."
          rows={3}
          className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm outline-none focus:border-sky-400 focus:ring-2 focus:ring-sky-100"
        />
        <button
          type="submit"
          className="mt-2 rounded-md bg-slate-900 px-3 py-1.5 text-sm font-medium text-white hover:bg-slate-800"
        >
          Add comment
        </button>
      </form>

      {comments.length === 0 ? (
        <p className="text-sm text-slate-500">No comments yet. Comments are stored locally until backend sync is available.</p>
      ) : (
        <div className="space-y-3">
          {comments.map((comment) => (
            <div key={comment.id} className="rounded-lg border border-slate-100 px-3 py-2">
              <p className="text-sm text-slate-800">{comment.text}</p>
              <p className="mt-1 text-xs text-slate-500">
                {comment.author || 'You'} · {new Date(comment.created_at).toLocaleString()}
              </p>
            </div>
          ))}
        </div>
      )}
    </WorkflowUtilityPanel>
  );
};

export default WorkflowCommentsPanel;
